export default {
  FETCH_ROLES_SUCCESS: "FETCH_ROLES_SUCCESS",
  FETCH_ROLES_LOADING: "FETCH_ROLES_LOADING",
  FETCH_ROLES_REJECT: "FETCH_ROLES_REJECT",
  FETCH_ROLES_FAILED: "FETCH_ROLES_FAILED",

};